import { Button } from '@material-ui/core'
import { LoyaltyRounded } from '@material-ui/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMainPageWelcomeSectionStyles } from './main-page-welcome-section.styles'

export const MainPageWelcomeSection: React.FC = () => {
  const classes = useMainPageWelcomeSectionStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.welcomeSection}>
      <div className={classes.welcomeBgHolder}>
        <div className={classes.welcomeBgIcon}>
          <LoyaltyRounded color="inherit" fontSize="inherit" />
        </div>
      </div>
      <div className={classes.welcomeHolder}>
        <div className={classes.welcomeInfoHolder}>
          <div className={classes.welcomeIcon}>
            <LoyaltyRounded color="inherit" fontSize="inherit" />
          </div>
          <div className={classes.welcomeText}>{t('mainPage.welcome.text')}</div>
        </div>
        <div className={classes.welcomeBtnHolder}>
          <Button
            className={classes.welcomeBtn}
            fullWidth
            variant="contained"
            onClick={() =>
              window.open('https://prosphora.github.io/link-to-help-hardcoded')
            }
            size="medium"
            color="primary"
          >
            {t('mainPage.welcome.readMore')}
          </Button>
        </div>
      </div>
    </div>
  )
}
